export default __webpack_public_path__ + "static/media/icon-lessons.459d6166.svg";